module.exports = __webpack_public_path__ + "img/termo_perso2.a5ea41cb.png";